// Copyright 2016 Sorama B.V.

import { bindable, bindingMode, customElement, inject } from "aurelia-framework";

@customElement("editable-field")
@inject(Element)
export class EditableField {
    private static editEventName = "edit";
    private static acceptEventName = "accept";
    private static cancelEventName = "cancel";

    private element: Element;

    //#region Bindable Properties
    @bindable({ defaultBindingMode: bindingMode.oneWay, defaultValue: true })
    isEditable: boolean;

    @bindable({ defaultBindingMode: bindingMode.oneWay, defaultValue: true })
    hasEditingState: boolean;

    @bindable({ defaultBindingMode: bindingMode.oneWay, defaultValue: true })
    canAccept: boolean;
    //#endregion

    //#region Fields
    private isEditing = false;
    //#endregion

    constructor(element: Element) {
        this.element = element;
    }

    private isEditableChanged(newValue: boolean, oldValue: boolean): void {
        if (this.isEditing) {
            this.isEditing = false;
        }
    }

    public edit(): void {
        if (this.hasEditingState) {
            this.isEditing = true;
        }

        const editEvent = new CustomEvent(EditableField.editEventName, <CustomEventInit>{
            bubbles: true,
        });

        this.element.dispatchEvent(editEvent);
    }

    public accept(): void {
        this.isEditing = false;

        const acceptEvent = new CustomEvent(EditableField.acceptEventName, <CustomEventInit>{
            bubbles: true,
        });

        this.element.dispatchEvent(acceptEvent);
    }

    public cancel(): void {
        this.isEditing = false;

        const cancelEvent = new CustomEvent(EditableField.cancelEventName, {
            bubbles: true,
        });

        this.element.dispatchEvent(cancelEvent);
    }
}
